import { CLEAR_SEARCH_RESULTS } from '../ActionTypes';

const clearSearchResults = () => ({ type: CLEAR_SEARCH_RESULTS });

export default clearSearchResults;
